export default __webpack_public_path__ + "static/lb-04-093dbdf3a94cbd1ce0306e3a6ffd5dc9.webp";